import type { FragmentHighlight } from 'features/knowledgeDocumentViewer/types'

export function citedQuotesFragment(
  pageNum: number,
  quotes: string[] | undefined,
  sourceVersion?: string
): FragmentHighlight | undefined {
  const citedQuotes = quotes?.filter((quote) => quote.trim().length > 0) ?? []
  if (citedQuotes.length === 0) return undefined
  return {
    pageNum,
    fragmentText: citedQuotes[0],
    quotes: citedQuotes,
    ...(sourceVersion ? { sourceVersion } : {}),
  }
}
